import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../../lib/supabase'
import { useAuth } from '../../context/AuthContext'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import EditProfileForm from './components/EditProfileForm'
import LoadingSpinner from '../../components/LoadingSpinner'

export default function Profile() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [supporter, setSupporter] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) { navigate('/login'); return }
    const fetchSupporter = async () => {
      const { data } = await supabase
        .from('supporters')
        .select('*, chapters(name), clubs(name)')
        .eq('id', user.id)
        .single()
      if (data) setSupporter(data)
      setLoading(false)
    }
    fetchSupporter()
  }, [user, navigate])

  if (loading) {
    return <LoadingSpinner fullScreen message="Loading your profile..." />
  }

  const initials = supporter?.full_name
    ?.split(' ').map((n) => n[0]).join('').toUpperCase()

  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col">
      <Navbar />
      <div className="flex-1 px-4 sm:px-6 lg:px-8 py-6 lg:py-10 max-w-3xl mx-auto w-full">
        <div className="mb-6 lg:mb-10">
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2">
            My Profile
          </h1>
          <p className="text-gray-500 text-sm">Manage your personal details</p>
        </div>

        {/* Profile Header */}
        <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 px-4 sm:px-8 py-5 sm:py-6 mb-6 flex items-center gap-4 sm:gap-6">
          <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full overflow-hidden bg-green-900/50 border-2 border-green-700/50 flex items-center justify-center text-white font-black text-lg sm:text-xl shrink-0">
            {supporter?.profile_photo ? (
              <img src={supporter.profile_photo} alt="Profile" className="w-full h-full object-cover" />
            ) : (
              <span>{initials}</span>
            )}
          </div>
          <div className="min-w-0">
            <div className="font-black text-lg sm:text-xl uppercase tracking-tight text-gray-900 dark:text-white truncate">
              {supporter?.full_name}
            </div>
            <div className="text-gray-500 text-xs sm:text-sm mt-1 truncate">
              {supporter?.membership_id} · {supporter?.clubs?.name}
            </div>
          </div>
        </div>

        <EditProfileForm supporter={supporter} setSupporter={setSupporter} />
      </div>
      <Footer />
    </div>
  )
}